import { render, staticRenderFns } from "./merchantList.vue?vue&type=template&id=f493135e&scoped=true&"
import script from "./merchantList.vue?vue&type=script&lang=js&"
export * from "./merchantList.vue?vue&type=script&lang=js&"
import style0 from "./merchantList.vue?vue&type=style&index=0&id=f493135e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f493135e",
  null
  
)

component.options.__file = "merchantList.vue"
export default component.exports